import { render, staticRenderFns } from "./StarFavoriteMedia.vue?vue&type=template&id=87444bb2&scoped=true"
import script from "./StarFavoriteMedia.vue?vue&type=script&lang=js"
export * from "./StarFavoriteMedia.vue?vue&type=script&lang=js"
import style0 from "./StarFavoriteMedia.vue?vue&type=style&index=0&id=87444bb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87444bb2",
  null
  
)

export default component.exports